import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";

export class PagingPanel extends Phaser.GameObjects.Container {

    public static HEIGHT = 100;

    private callback: (page: number) => unknown;
    private page: number;

    constructor(scene: Phaser.Scene, pageCurr: number, pageMax: number, callback: (page: number) => unknown, adminNavigation?: boolean){
        super(scene);
        this.callback = callback;
        this.page = pageCurr;
        let self = this;

        this.scene = scene;
        //this.width = CanvasUtils.CANVAS_WIDTH;
        this.height = PagingPanel.HEIGHT;

        if (pageMax <= 1) {
            this.setVisible(false);
        }

        let availablePages: number[] = this.getAvailablePageNumbers(pageCurr, pageMax);
        let pageWidth = 50;

        let xPos = -25 - availablePages.length / 2 * pageWidth;

        let leftButton = SpriteUtils.addImage(this.scene!, xPos, 50, Keys.ATLAS_PROFILE, Keys.UI_ARROW_LEFT, 1.3);
        leftButton.setInteractive().on('pointerdown', () => {
            self.callCallback(1)
        });
        this.add(leftButton);

        if(adminNavigation){
            let leftButton10 = SpriteUtils.addImage(this.scene!, xPos - 37, 50, Keys.ATLAS_PROFILE, Keys.UI_ARROW_LEFT, 1.3);
            leftButton10.setInteractive().on('pointerdown', () => {
                self.callCallback(Math.max(1, pageCurr - 10))
            });
            this.add(leftButton10);

            let minus10text = TextUtils.addTextAdvanced(scene, '10', xPos - 37 + 2, 48,
                '#000000', 13, 'normal', 50, 'center', 1, Fonts.MYRIADPRO_BOLD);
            minus10text.setStroke('#b88735', 2)
            minus10text.setShadowOffset(0, 0);
            this.add(minus10text);

            let leftButton100 = SpriteUtils.addImage(this.scene!, xPos - 74, 50, Keys.ATLAS_PROFILE, Keys.UI_ARROW_LEFT, 1.3);
            leftButton100.setInteractive().on('pointerdown', () => {
                self.callCallback(Math.max(1, pageCurr - 100))
            });
            this.add(leftButton100);

            let minus100text = TextUtils.addTextAdvanced(scene, '100', xPos - 74 + 2, 48,
                '#000000', 13, 'normal', 50, 'center', 1, Fonts.MYRIADPRO_BOLD);
            minus100text.setStroke('#b88735', 2)
            minus100text.setShadowOffset(0, 0);
            this.add(minus100text);
        }

        xPos += pageWidth;

        for (let p of availablePages) {
            let pageButton = SpriteUtils.addImage(this.scene!, xPos, 50, p == pageCurr? Keys.FRM_PAGING_BUTTON2 : Keys.FRM_PAGING_BUTTON, undefined, 1.15);
            if (p !== pageCurr) {
                pageButton.setInteractive().on('pointerdown', () => {
                    self.callCallback(p);
                });
            } else {
                pageButton.alpha = 0.3;
            }
            this.add(pageButton);

            let pageText = TextUtils.addTextAdvanced(scene, String(p), xPos, 50,
                '#ffd565', p == pageCurr? 13 : 14, 'normal', 50, 'center', 1, Fonts.MYRIADPRO_REGULAR);
            this.add(pageText);
            xPos += pageWidth;
        }

        let rightButton = SpriteUtils.addImage(this.scene!, xPos, 50, Keys.ATLAS_PROFILE, Keys.UI_ARROW_LEFT, -1.3, 1.3);
        rightButton.setInteractive().on('pointerdown', () => {
            self.callCallback(pageMax);
        });
        this.add(rightButton);

        if(adminNavigation){
            let rightButton10 = SpriteUtils.addImage(this.scene!, xPos + 37, 50, Keys.ATLAS_PROFILE, Keys.UI_ARROW_LEFT, -1.3, 1.3);
            rightButton10.setInteractive().on('pointerdown', () => {
                self.callCallback(Math.min(pageCurr + 10, pageMax));
            });
            this.add(rightButton10);
            let plus10text = TextUtils.addTextAdvanced(scene, '10', xPos + 37 - 2, 48,
                '#000000', 13, 'normal', 50, 'center', 1, Fonts.MYRIADPRO_BOLD);
            plus10text.setStroke('#b88735', 2)
            plus10text.setShadowOffset(0, 0);
            this.add(plus10text);

            let rightButton100 = SpriteUtils.addImage(this.scene!, xPos + 74, 50, Keys.ATLAS_PROFILE, Keys.UI_ARROW_LEFT, -1.3, 1.3);
            rightButton100.setInteractive().on('pointerdown', () => {
                self.callCallback(Math.min(pageCurr + 100, pageMax));
            });
            this.add(rightButton100);
            let plus100text = TextUtils.addTextAdvanced(scene, '100', xPos + 74 - 2, 48,
                '#000000', 13, 'normal', 50, 'center', 1, Fonts.MYRIADPRO_BOLD);
            plus100text.setStroke('#b88735', 2)
            plus100text.setShadowOffset(0, 0);
            this.add(plus100text);
        }
    }

    protected getAvailablePageNumbers(currentPage: number, pageCount: number): number[] {

        if (pageCount == 1) {
            return [];
        }

        // if (currentPage == 1) {
        //     return [1, 2]
        // } else if (currentPage == pageCount){
        //     return [pageCount - 1, pageCount];
        // } else{
        //     return [currentPage-1, currentPage, currentPage+1];
        // }
        let res = [];
        for (let i = currentPage-2; i <= currentPage+2; i++) {
            if (i >= 1 && i <= pageCount) {
                res.push(i);
            }
        }
        return res;

    }

    public getPage(): number {
        return this.page;
    }

    private callCallback(page: number) {
        this.page = page;
        this.callback(page);
    }
}
